import { render, staticRenderFns } from "./vipService.vue?vue&type=template&id=b594a240"
import script from "./vipService.vue?vue&type=script&lang=js"
export * from "./vipService.vue?vue&type=script&lang=js"
import style0 from "./vipService.vue?vue&type=style&index=0&id=b594a240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports